import { motion } from "framer-motion";
import React from "react";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

interface HomePageProps {
  onEnter: () => void;
}

const focusRing =
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-400 focus-visible:ring-offset-2";

const HomePage: React.FC<HomePageProps> = ({ onEnter }) => {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <div className="relative min-h-screen overflow-hidden">
      <div
        className="hub-aurora pointer-events-none absolute inset-0"
        aria-hidden
      />
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 py-16">
        <motion.div
          className="max-w-lg space-y-8 text-center"
          initial={reducedMotion ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={
            reducedMotion
              ? { duration: 0 }
              : { duration: 0.75, ease: "easeOut" }
          }
        >
          <p className="text-sm font-medium uppercase tracking-widest text-rose-600/90">
            Twogether
          </p>
          <h1 className="text-3xl font-semibold leading-snug text-gray-900 md:text-4xl">
            우리들의 추억을
            <br />
            모아보는 장소
          </h1>
          <p className="text-lg leading-relaxed text-gray-600">
            함께 걸어온 날들을 한곳에 담아봤어요~
            <br />
            천천히 둘러봐봐요!
          </p>
          <p className="text-sm leading-relaxed text-gray-500">
            잊지 않으려고 모아 둔 작은 추억 저장소에요~ 앞으로도 최대한 업데이트
            해볼게요~!
          </p>
          <motion.button
            type="button"
            onClick={onEnter}
            className={`inline-flex items-center justify-center rounded-full bg-gray-900 px-8 py-3.5 text-base font-medium text-white shadow-lg transition-colors hover:bg-gray-800 ${focusRing}`}
            whileHover={reducedMotion ? undefined : { scale: 1.02 }}
            whileTap={reducedMotion ? undefined : { scale: 0.98 }}
          >
            추억 보러 가기
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage;
